(() => {
  const config = window.scFlash;
  if (!config) return;
  const end = Date.parse(config.endsAt);
  if (!Number.isFinite(end)) return;
  let ticker;
  const pad = n => String(n).padStart(2, '0');
  const panelData = new WeakMap();
  const syncPrices = () => {
    document.querySelectorAll('[data-sc-flash-pdp]').forEach(panel => {
      let prices = panelData.get(panel);
      if (!prices) {
        try { prices = JSON.parse(panel.querySelector('[data-sc-flash-variants]').textContent); }
        catch (_) { return; }
        panelData.set(panel, prices);
      }
      let scope = panel.parentElement;
      while (scope && scope !== document.body && !scope.querySelector('form[action*="/cart/add"]')) scope = scope.parentElement;
      if (!scope || scope === document.body) return;
      const field = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const selected = field && prices[field.value];
      if (!selected) return;
      ['final', 'was'].forEach((key, i) => {
        const element = panel.querySelector('[data-sc-flash-' + key + ']');
        if (element && element.textContent !== selected[i]) element.textContent = selected[i];
      });
    });
  };
  const tick = () => {
    const remaining = end - Date.now();
    if (remaining <= 0) {
      document.documentElement.classList.add('sc-flash-ended');
      document.querySelectorAll('[data-sc-flash-pdp], [data-big-surf-hero], [data-sc-flash-card], .sc-flash-sticker').forEach(el => el.hidden = true);
      document.querySelectorAll('[data-big-surf-fallback]').forEach(el => el.hidden = false);
      window.scFlash = null;
      clearInterval(ticker);
      return;
    }
    const seconds = Math.floor(remaining / 1000);
    const parts = { days: Math.floor(seconds / 86400), hours: pad(Math.floor(seconds % 86400 / 3600)), minutes: pad(Math.floor(seconds % 3600 / 60)), seconds: pad(seconds % 60) };
    document.querySelectorAll('[data-sc-flash-timer]').forEach(timer => {
      for (const [key, value] of Object.entries(parts)) {
        const el = timer.querySelector('[data-sc-' + key + ']');
        if (el && el.textContent !== String(value)) el.textContent = value;
      }
      timer.hidden = false;
    });
    document.querySelectorAll('[data-sc-card-left]').forEach(element => {
      if (!element.dataset.ready) {
        const label = document.createElement('span');
        label.className = 'sc-flash-card-timer__label';
        label.textContent = config.endsIn;
        element.append(label);
        element.setAttribute('aria-label', config.deadline);
        Object.keys(parts).forEach((key, index) => {
          const cell = document.createElement('span');
          cell.className = 'sc-flash-card-timer__cell';
          cell.setAttribute('aria-hidden', 'true');
          const number = document.createElement('b');
          number.dataset.scCardUnit = key;
          const unit = document.createElement('small');
          unit.textContent = config.units[index];
          cell.append(number, unit);
          element.append(cell);
        });
        element.dataset.ready = 'true';
      }
      element.querySelectorAll('[data-sc-card-unit]').forEach(number => {
        const value = String(parts[number.dataset.scCardUnit]);
        if (number.textContent !== value) number.textContent = value;
      });
    });
    syncPrices();
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-sc-flash-copy]');
    if (!button || Date.now() >= end) return;
    const panel = button.closest('[data-sc-flash-pdp], [data-big-surf-hero]');
    const status = panel && panel.querySelector('[data-sc-flash-status]');
    const original = button.textContent;
    try {
      await navigator.clipboard.writeText(config.code);
      button.textContent = config.copied;
      if (status) status.textContent = config.copySuccess;
      setTimeout(() => button.textContent = original, 2400);
    } catch (_) {
      if (status) status.textContent = config.copyFallback;
    }
  });
  document.addEventListener('change', () => setTimeout(syncPrices, 0));
  ticker = setInterval(tick, 1000);
  tick();
  document.addEventListener('shopify:section:load', tick);
  document.addEventListener('visibilitychange', tick);
})();


